import setLoading from 'components/loading';
import { getCurrentDateTime } from 'utils'
import stateManager from './saveHtml';

const holder = {
  closeDateSelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter('isOpen', false);
      document.removeEventListener('mousedown', holder.closeDateSelector);
    }
  }
};

const convertToHtml = (data) => {
  let dt = [...data];
  let html = '<table class="table"><thead><tr>';
  dt.shift().forEach(header => {
    html += `<th style="text-align:left">${header}</th>`
  });
  html += '</tr><tbody>';
  dt.forEach(row => {
    html += '<tr>';
    row.forEach(c => {
      html += `<td>${c}</td>`
    })
    html += '</tr>';
  });

  html += '</tbody></table>'
  return html
}


export default {

  'ExportMakeReadyCards.RelativeWrapper.Selector': async ({ isOpen, containerRef }, _, internalStateSetter) => {
    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = containerRef;
    await internalStateSetter('isOpen', !isOpen);
    if (isOpen) {
      document.removeEventListener('mousedown', holder.closeDateSelector);
    } else {
      document.addEventListener('mousedown', holder.closeDateSelector);
    }
  },
  'ExportMakeReadyCards.RelativeWrapper.DropdownWrapper.Wrapper.Csv': ({ }, internalStateSetter) => {
    internalStateSetter({ isOpen: false });
  },
  'ExportMakeReadyCards.RelativeWrapper.DropdownWrapper.Wrapper.Csv.CsvExport': async ({ }, internalStateSetter) => {
    await internalStateSetter({ isOpen: false });
  },
  'ExportMakeReadyCards.RelativeWrapper.DropdownWrapper.Wrapper.Pdf': ({ fileName, csvData, fetchingPDF }, outlet, internalStateSetter) => {
    if (!fetchingPDF) {
      setLoading(true);
      internalStateSetter('fetchingPDF', true)
      const html = convertToHtml(csvData)

      const promise = stateManager.saveHtml({ html, options: { date: getCurrentDateTime() } });
      promise.then((r) => {
        const source = `data:application/pdf;base64,${r.data}`;
        const link = document.createElement("a");
        link.href = source;
        link.download = fileName;
        document.body.appendChild(link)
        link.click();
        document.body.removeChild(link)
      })
      promise.catch((e) => {
        console.warn(e);
        setError(true);
      });
      promise.finally(() => {
        internalStateSetter('fetchingPDF', false)
        internalStateSetter({ isOpen: false });
        setLoading(false)
      });
    }
  },
  'ExportMakeReadyCards.RelativeWrapper.DropdownWrapper.Wrapper.Subscribe': ({ }, outlet, internalStateSetter) => {
    outlet({ action: 'subscribe' })
    internalStateSetter({ isOpen: false });
  }
}
